import { fabric } from 'fabric';

import { InternalCanvas } from '../canvas';
import { DrawingTool, ObjectBuilder, UpdateObjectRect } from './tool';

class ArrowBuilder extends ObjectBuilder<fabric.Polyline> {
    private _polylineInit: fabric.IPolylineOptions;

    public constructor(canvas: InternalCanvas, initialPoint: fabric.Point) {
        const polylineOptions = {
            strokeWidth: canvas.brushWidth,
            stroke: canvas.brushColor,
            fill: canvas.brushColor,
        };
        super(initialPoint, new fabric.Polyline([], polylineOptions));
        this._polylineInit = polylineOptions;
    }

    protected _updateObject({ x1, y1, x2, y2 }: UpdateObjectRect): void {
        const fromx = x1;
        const fromy = y1;
        const tox = x2;
        const toy = y2;
        const angle = Math.atan2(toy - fromy, tox - fromx);

        if (!this._object.strokeWidth) {
            throw new Error('object is missing stroke width');
        }

        const tailWidthMultiplier = this._object.strokeWidth / 2;
        const headlen = tailWidthMultiplier * 4;

        const points = [
            {
                x: fromx, // start point
                y: fromy,
            },
            {
                x: fromx - tailWidthMultiplier * Math.cos(angle - Math.PI / 2),
                y: fromy - tailWidthMultiplier * Math.sin(angle - Math.PI / 2),
            },
            {
                x: tox - tailWidthMultiplier * Math.cos(angle - Math.PI / 2),
                y: toy - tailWidthMultiplier * Math.sin(angle - Math.PI / 2),
            },
            {
                x: tox - headlen * Math.cos(angle - Math.PI / 2),
                y: toy - headlen * Math.sin(angle - Math.PI / 2),
            },
            {
                x: tox + headlen * Math.cos(angle), // tip
                y: toy + headlen * Math.sin(angle),
            },
            {
                x: tox - headlen * Math.cos(angle + Math.PI / 2),
                y: toy - headlen * Math.sin(angle + Math.PI / 2),
            },
            {
                x: tox - tailWidthMultiplier * Math.cos(angle + Math.PI / 2),
                y: toy - tailWidthMultiplier * Math.sin(angle + Math.PI / 2),
            },
            {
                x: fromx - tailWidthMultiplier * Math.cos(angle + Math.PI / 2),
                y: fromy - tailWidthMultiplier * Math.sin(angle + Math.PI / 2),
            },
            {
                x: fromx,
                y: fromy,
            },
        ] as fabric.Point[];

        this._object.set({ points, dirty: true });
        this._object._setPositionDimensions(this._polylineInit);
    }
}

export class ArrowTool extends DrawingTool {
    public createObjectBuilder(
        canvas: InternalCanvas,
        initialPoint: fabric.Point,
    ): ArrowBuilder {
        return new ArrowBuilder(canvas, initialPoint);
    }
}
